module.exports = __webpack_public_path__ + "img/avatar.3f76349e.png";